/**
 * useBanStatus — verifica daca user-ul curent e banat si expune
 * status-ul cu re-fetch periodic (la fiecare 30s).
 *
 * Folosit de UploadPage / Gallery (pentru a bloca actiunile) si de
 * orice pagina care vrea sa afiseze mesajul de suspendare.
 */

import { useQuery } from '@tanstack/react-query';
import { checkMyBanStatus } from '@/lib/admin';

export function useBanStatus() {
  return useQuery({
    queryKey: ['my-ban-status'],
    queryFn: checkMyBanStatus,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}